<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-search-box">
                    <div class="input-group">
                        <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search" @keypress.enter="initList">
                        <div class="input-group-append">
                            <button class="all-btn search-btn" @click="initList">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" @click="showExpert2OrganizationEditModal(null)">{{$t("action.add")}}</button>
              </div>

            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>#</th>
                      <th width="15%">Номи</th>
                      <th width="15%">Номи(ru)</th>
                      <th width="30%">Манзил</th>
                      <th>Актив</th>
                      <th>Тартиб</th>
                      <th class="text-center">{{$t("realEstate.field.action")}}</th>
                  </tr>
                  </thead>
                  <tbody v-if="!loading && results && results.data">
                  <tr v-for="result in results.data" :key="result.id">
                      <td>{{result.id}}</td>
                      <td>{{result.name}}</td>
                      <td>{{result.nameRu}}</td>
                      <td>{{result.address}}</td>
                      <td>{{result.active ? 'Ха' : 'Йўқ'}}</td>
                      <td>{{result.sortOrder}}</td>
                      <td class="td-actions text-center">
                          <button class="all-btn edit-btn table-action" data-original-title="Edit" @click="showExpert2OrganizationEditModal(result)">
                              <i class="fa fa-edit"></i>
                          </button>
                      </td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <Expert2OrganizationEditModal @change="initList"/>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import Expert2OrganizationEditModal from '@/views/config/expert2/Expert2OrganizationEditModal'
    export default {
        name: "Expert2OrganizationList",
        components: {
            'b-pagination': bPagination,
          Expert2OrganizationEditModal
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('expert2/organization/list', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showExpert2OrganizationEditModal(data) {
                this.$eventBus.$emit('showExpert2OrganizationEditModal', data);
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>